import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import Swal from "sweetalert2";
import BaseMixer from "@/router/views/BaseMixer";
let ECAlert = /** @class */ (() => {
    let ECAlert = class ECAlert extends Mixins(BaseMixer) {
        AlertConfirmation() {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                title: this.title,
                text: this.text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    return this.save();
                }
                return this.cancel();
            });
        }
        save() { }
        cancel() { }
        created() {
            this.AlertConfirmation();
            // text: `You can reverse this action later.`,
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], ECAlert.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], ECAlert.prototype, "text", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ECAlert.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ECAlert.prototype, "cancel", null);
    ECAlert = __decorate([
        Component({
            name: "ECAlert",
            components: {},
        })
    ], ECAlert);
    return ECAlert;
})();
export default ECAlert;
